export default __webpack_public_path__ + "static/media/squad-player-1.75048810.png";